export type GlobalPopupStateModel = typeof globalPopupState;

export const globalPopupState = {
  showGlobalPopup: false,
  headerText: '',
  bodyText: '',
  leftButton: '',
  rightButton: '',
};
